import css from './styles.module.scss'

import { Button, Col, Typography } from 'antd'

import { imagePicker } from '@utils/imagePicker'
import { StyledBox } from '@pages/objects/common/components'


interface HeaderProps {
    objectName: string
    setObjectName: React.Dispatch<React.SetStateAction<string>>
}

export const Header: React.FC<HeaderProps> = ({ objectName }) => {
    return (
        <>
            <Col 
                className={css.styles}
                span={'8'}
            >
                <StyledBox>
                    <img
                        className='avatar'
                        src={imagePicker({ picture: ''})}
                    />
                    <Button className='img_upload'>Заменить</Button>
                </StyledBox>
            </Col>
            <Col flex={1}>
                <StyledBox>
                    <p>Название</p>
                    <Typography.Title level={4}>{objectName}</Typography.Title>
                </StyledBox>
            </Col>
        </>
    )
}
